import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import ShowCard from "../../Components/ShowCard/ShowCard";
import { ToastContainer, toast } from "react-toastify";
import { useWindowWidth } from "@react-hook/window-size";
import Translate, { useTranslateText } from "../../Components/Multilanguage/Translate";

import * as service from "./service";
import { rowItemCount } from "../../utils/utils";
import GaiaCard from "../../Components/ShowCard/GaiaCard";
import GaiaCategories from "../homepage/Components/GaiaSlider/GaiaCategories";
import AddToPlaylistPopup from "../ShowDetailsScreen/Components/AddToPlaylistPopup";

const MyList = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const myListRedux = useSelector((state) => state?.myList?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const translateText = useTranslateText();
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [rowItemsClass, setRowItemsClass] = useState("");
  const [showDeletePlaylistPopup, setShowDeletePlaylistPopup] = useState(false);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const pubid = projectInfo?.projectConfig?.pubid || projectInfo?.pubid;
  const isYowTv = pubid == 50187 || Number(pubid) === 50187;
  const [rowItemCountNumber, setRowItemCountNumber] = useState(isYowTv ? 6 : 5);

  const location = useLocation();
  const navigate = useNavigate();
  const windowSize = useWindowWidth();

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    if (
      projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT"
    ) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    if (isYowTv) {
      setRowItemsClass("rowCount6");
      setRowItemCountNumber(6);
      return;
    }
    if (windowSize > 980) {
      if (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) {
        const rClass = rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT);
        setRowItemsClass(rClass);
        setRowItemCountNumber(parseInt(rClass.replace(/\D/g, ''), 10) || 5);
      } else {
        setRowItemsClass("rowCount4");
        setRowItemCountNumber(4);
      }
    } else {
      setRowItemsClass("");
      if (windowSize > 767) {
        setRowItemCountNumber(2);
      } else if (windowSize > 319) {
        setRowItemCountNumber(1);
      }
    }
  }, [projectInfo, windowSize, isYowTv]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    fetchWatchlistShows();
  }, []);

  useEffect(() => {
    if (myListRedux) {
      setShows(myListRedux);
    }
  }, [myListRedux]);

  const fetchWatchlistShows = async () => {
    try {
      const response = await service.fetchWatchlistShows(appInfo);
      if (response?.status === 200) {
        setShows(response?.data?.data);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
  };

  if (loading) {
    return <Loading />;
  }

  // Playlist-wise view for YowTV (pubid 50187) using /show/watchlistV2
  if (isYowTv) {
    return (
      <div className={`myList ${isRTL ? "rtl" : ""} yowtv-my-list-container`}>
        <ToastContainer />
        <AddToPlaylistPopup
          isOpen={showDeletePlaylistPopup}
          onClose={() => setShowDeletePlaylistPopup(false)}
          type="delete"
        />
        <div className="homePage gaia" style={{ paddingTop: "110px", minHeight: "80vh" }}>
          <div
            className="favorites-header-wrapper"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: windowSize <= 640 ? "0 20px 20px" : "0 4.5% 20px",
            }}
          >
            <h1
              className="heading gaia"
              style={{
                margin: 0,
                color: "var(--color-text-primary, #F6F6F6)",
                fontFamily: "Archivo",
                fontSize: windowSize <= 640 ? "24px" : "32px",
                fontWeight: "700",
              }}
            >
              <Translate textKey={"my_list"} />
            </h1>
            <div
              className="favorites-header-button"
              title={translateText("delete_playlist") || "Delete Playlist"}
              style={{ padding: 0 }}
            >
              <svg
                className="favorites-header-btn"
                width="28"
                height="28"
                onClick={() => setShowDeletePlaylistPopup(true)}
                onMouseEnter={(e) => (e.currentTarget.style.stroke = "var(--button-hover, #FFC800)")}
                onMouseLeave={(e) => (e.currentTarget.style.stroke = "var(--button-color, #F6F6F6)")}
                viewBox="0 0 24 24"
                fill="none"
                style={{ cursor: "pointer", stroke: "var(--button-color, #F6F6F6)" }}
              >
                <path d="M10 12V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 12V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 7H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>

          {Array.isArray(shows) &&
            shows.map((playlist, index) => {
              const categoryData = {
                category_name: playlist?.title,
                shows: playlist?.shows,
                type: "WATCHLIST",
                visible_items_count: isYowTv ? 6 : undefined,
                show_all_needed: (playlist?.shows?.length || 0) > (isYowTv ? 6 : rowItemCountNumber),
                key: `playlist_${playlist?.playlist_id}`,
                thumbnail_orientation:
                  projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION,
                playlist_id: playlist?.playlist_id,
                playlistData: playlist,
              };

              const handleRemoveFromList = (catId, videoId) => {
                setShows((prevShows) => {
                  if (!Array.isArray(prevShows)) return prevShows;
                  return prevShows.map((pl) => {
                    if (pl.playlist_id === playlist.playlist_id) {
                      return {
                        ...pl,
                        shows: (pl.shows || []).filter((s) => s.video_id !== videoId),
                      };
                    }
                    return pl;
                  });
                });
              };

              return (
                <GaiaCategories
                  key={playlist?.playlist_id ?? index}
                  data={categoryData}
                  fromFavoritesScreen={true}
                  onRemoveItem={handleRemoveFromList}
                />
              );
            })}

          {(!Array.isArray(shows) || shows.length === 0) && !loading && (
            <div className="favourite-empty-state">
              <h2>
                <Translate textKey="no_data_found" />
              </h2>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Legacy single-list grid for non-YowTV publishers
  return (
    <div className={`myList ${isRTL ? "rtl" : ""}`}>
      <ToastContainer />

      <div className="wrapper">
        <div className="top">
          <h1 className="heading">
            <Translate textKey={"my_list"} />
          </h1>
        </div>
        <div className="bottom">
          <div className="itemsContainer">
            {shows?.map((item, index) => (
              <div
                key={index}
                className={
                  thumbnailOrientation === `PORTRAIT`
                    ? `items portrait ${rowItemsClass}`
                    : `items landscape ${rowItemsClass}`
                }
              >
                {template === "TEMPLATE_10" ? (
                  <GaiaCard
                    data={item}
                    key={index}
                    imageUrl={true}
                    season={false}
                    metaData={true}
                    modalNavigation={true}
                    thumbnailOrientation={thumbnailOrientation}
                  />
                ) : (
                  <ShowCard
                    data={item}
                    key={index}
                    imageUrl={true}
                    season={false}
                    metaData={true}
                    modalNavigation={true}
                    thumbnailOrientation={thumbnailOrientation}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyList;
